export const BREAK_TIME = 60 * 6;
export const BREAK_DURATION = 30;
export const TIME_BETWEEN_TRIPS = 5;
export const PRE_ROUTE_CO = 'pre-route-co';
export const POST_ROUTE_CO = 'post-route-co';
export const ROUTE_COORDINATION_DURATION = 10;
